exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PinPuk_container_1Dyn:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n.PinPuk_gray_fLNK {\n  color: #787878;\n}\n\n.PinPuk_preloader_Lvt5 {\n  position: static;\n\n  -webkit-transform: none;\n\n          transform: none;\n}\n\n.PinPuk_statusFail_3j9W {\n  margin-top: 10px;\n\n  max-width: 450px;\n\n  font-size: 15px;\n  text-align: left;\n}\n\n.PinPuk_pinPukWrapper_3Htm {\n  margin-bottom: 5px;\n\n  display: inline-block;\n}\n\n.PinPuk_pinPuk_3d8k {\n  margin-right: 30px;\n\n  display: inline-block\n}\n\n@media (min-width: 1024px) {\n\n  .PinPuk_pinPuk_3d8k:last-child {\n    margin-right: 60px;\n  }\n}\n\n.PinPuk_hint_1f_q {\n  margin-bottom: 7px;\n}\n\n.PinPuk_helpLink_16-Z {\n  display: inline-block;\n}\n", ""]);

// exports
exports.locals = {
	"container": "PinPuk_container_1Dyn",
	"gray": "PinPuk_gray_fLNK",
	"preloader": "PinPuk_preloader_Lvt5",
	"statusFail": "PinPuk_statusFail_3j9W",
	"pinPukWrapper": "PinPuk_pinPukWrapper_3Htm",
	"pinPuk": "PinPuk_pinPuk_3d8k",
	"hint": "PinPuk_hint_1f_q",
	"helpLink": "PinPuk_helpLink_16-Z"
};